import { AspectRatio, Box, Flex, FlexProps, Grid, GridItem, Icon, Image, Link, Text } from "@chakra-ui/react";
import { KeyIcon, OpenSeaIcon } from "@components/icons";
import TransparentModal from "@components/site/layout/TransparentModal";
import ProjectCard from "@components/site/projects/ProjectCard";
import { useWindowSiteStore } from "@store/windowSiteStore";
import { useState } from "react";

type GetAccessProps = {
    onClick?: Function;
    children?: React.ReactNode;
};

export const GetAccess = ({ onClick, children, ...props }: GetAccessProps & FlexProps) => {
    const [openAccessModal, setOpenAccessModal] = useState(false);
    const windowWidth = useWindowSiteStore((state) => state.windowWidth);

    const handleOpen = (e) => {
        e.stopPropagation();
        if (onClick) {
            onClick(e);
        }
        setOpenAccessModal(true);
    };

    const GetAccessModal = () => {
        return (
            <>
                <TransparentModal open={openAccessModal} close={() => setOpenAccessModal(false)}>
                    <Flex direction="column" gap={{ base: "15", md: "20px" }}>
                        <Text textStyle="site.header">Get Access</Text>
                        <Grid
                            // minW={300}
                            maxW={526}
                            w="100%"
                            columnGap={{ base: "10px", md: "20px" }}
                            rowGap={{ base: "20px", md: "30px" }}
                            templateColumns="auto 1fr"
                            textAlign="left"
                        >
                            <GridItem>
                                <Icon
                                    as={KeyIcon}
                                    fontSize={{ base: 48, md: 64 }}
                                    color="lavenderGray"
                                    my="-8px"
                                />
                            </GridItem>
                            <GridItem textStyle="site.gray.text">
                                Wall St Fam (WSF) NFTs are the key to getting full access to premium
                                features across all projects.
                            </GridItem>

                            <GridItem>
                                <Icon
                                    as={Image}
                                    src="/icons/get-access-heart.svg"
                                    fontSize={{ base: 48, md: 64 }}
                                    color="lavenderGray"
                                    my="-8px"
                                />
                            </GridItem>
                            <GridItem textStyle="site.gray.text">
                                They come in Moms & Dads, so pick whoever drives you the least
                                crazy. Use our app to find yours:
                            </GridItem>

                            <GridItem display={windowWidth > 500 ? "inherit" : "none"} />
                            <GridItem colSpan={windowWidth > 500 ? 1 : 2}>
                                <Grid w="100%" h="100%" columnGap="20px" templateColumns="1fr 1fr">
                                    <GridItem>
                                        <ProjectCard
                                            noStatsMode
                                            collection={{
                                                collectionId: "wallstreetdads",
                                                name: "Wall Street Dads",
                                                slug: "wallstreetdads",
                                                contract:
                                                    "0x03e99afd576eaf6b818d58a4efc59d2d0cbf1678",
                                                stats: null,
                                                supply: 3000,
                                                hasVibes: true,
                                                hasTraitWeights: true,
                                                complexityScore: 32.5,
                                                imageUrl: "/images/WSD-square.gif",
                                                featured: 0,
                                                featuredStartDate: null,
                                                featuredEndDate: null,
                                                firstPublishedToProduction: new Date(
                                                    "2022-10-17T22:27:25.344Z",
                                                ),
                                                externalUrl: "https://www.wallstfam.com",
                                                projectionIsPublic: true,
                                                dataVersion: "2",
                                            }}
                                        />
                                    </GridItem>
                                    <GridItem>
                                        <ProjectCard
                                            noStatsMode
                                            collection={{
                                                collectionId: "wallstmoms",
                                                name: "Wall St Moms",
                                                slug: "wallstmoms",
                                                contract:
                                                    "0xcf47faa5280289a54349be22df1a9674be16d3f8",
                                                stats: null,
                                                supply: 3000,
                                                hasVibes: true,
                                                hasTraitWeights: true,
                                                complexityScore: 38.8,
                                                imageUrl: "/images/WSM-square.gif",
                                                featured: 0,
                                                featuredStartDate: null,
                                                featuredEndDate: null,
                                                firstPublishedToProduction: new Date(
                                                    "2022-10-17T20:22:23.625Z",
                                                ),
                                                externalUrl: "https://www.wallstfam.com/",
                                                projectionIsPublic: true,
                                                dataVersion: "2",
                                            }}
                                        />
                                    </GridItem>
                                </Grid>
                            </GridItem>
                        </Grid>
                    </Flex>
                </TransparentModal>
            </>
        );
    };

    return (
        <>
            <GetAccessModal />
            <Flex onClick={handleOpen} {...props}>{children}</Flex>
        </>
    );
};
